











































import { Component, Vue } from 'vue-property-decorator';
import { authService } from '@/services/AuthService';
import Advert from '@/components/activation/Advert.vue';
import LanguageSwitch from '@/components/activation/LanguageSwitch.vue';
import EUProjectInfo from '@/components/activation/EUProjectInfo.vue';

@Component({
  components: {
    Advert,
    LanguageSwitch,
    EUProjectInfo,
  },
})
export default class ResetPassword extends Vue {
  email = '';
  isActiveEmailValidation = false;

  resetPassword() {
    this.isActiveEmailValidation = true;
    if (
      !this.email ||
      (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        this.email
      ) &&
        this.email)
    ) {
      return;
    }
    authService.resetPasswordEmail(this.email).then(() => {
      this.$router.push('/resend-pass').catch(() => {});
    });
  }
}
